import { useEffect, useState } from "react"
import { useWindowResize } from "./use-window-resize"

export const useWindowDimensions = () => {
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  })

  useWindowResize(() => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth,
    })
  })

  return dimensions
}
